function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _classPrivateFieldSet(s, a, r) { return s.set(_assertClassBrand(s, a), r), r; }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { makeAppId } from '../utils';
import { SpaSlot } from './SpaSlot';
var _slotCollection = /*#__PURE__*/new WeakMap();
export var SpaSlotCollection = /*#__PURE__*/function () {
  /**
   * @param {IlcConfigRoot} configRoot
   */
  function SpaSlotCollection(configRoot) {
    _classCallCheck(this, SpaSlotCollection);
    /**
     * @private
     * @property {Array<SpaSlot>}
     */
    _classPrivateFieldInitSpec(this, _slotCollection, []);
    var routes = configRoot.getConfigForRoutes();
    var route404 = configRoot.getConfigForSpecialRoutesByKey('404');
    var slotRoutes = [].concat(_toConsumableArray(routes), [route404]);
    var slotCollectionMap = new Map();
    slotRoutes.forEach(function (route) {
      var routeSlots = route.slots;
      var routeSlotsName = Object.keys(routeSlots);
      routeSlotsName.forEach(function (slotName) {
        var rawSlot = route.slots[slotName];
        var applicationId = makeAppId(rawSlot.appName, slotName);
        var slot = new SpaSlot({
          applicationId: applicationId,
          applicationName: rawSlot.appName,
          slotName: slotName
        }, configRoot);

        // Routes could contain overrides for slots
        // So it leads to situation when slot route could be duplicated per route
        if (!slotCollectionMap.get(applicationId)) {
          slotCollectionMap.set(applicationId, slot);
        }
      });
    });
    _classPrivateFieldSet(_slotCollection, this, Array.from(slotCollectionMap.values()));
  }

  /**
   * @public
   * @return Array<SpaSlot>
   */
  return _createClass(SpaSlotCollection, [{
    key: "getSlotCollection",
    value: function getSlotCollection() {
      return _classPrivateFieldGet(_slotCollection, this);
    }

    /**
     * @public
     * @return Array<{slotName: string, appName: string, appId: string}>
     */
  }, {
    key: "getSlotCollectionRaw",
    value: function getSlotCollectionRaw() {
      return _classPrivateFieldGet(_slotCollection, this).map(function (item) {
        return item.toJson();
      });
    }
  }]);
}();